import * as type from '@/constant/redux-const';
import { DEFAULT_PAGE_SIZE } from '@/utils/constant';
import { TRIP_REPORT_STATUS_ID, tripReportStatusList } from '@/constant/tripReports';

export interface ITripReportsFilter {
  clientName: string;
  status: Array<{ id: TRIP_REPORT_STATUS_ID; text: string; }>;
  broker: Array<number>;
  airports: Array<number>;
  aircraft_ids: Array<number>;
  operator_ids: Array<number>;
  tail_numbers: Array<string>;
  departureDate: string;
}

export type ITripReportsFilterField = 'tripId' | 'clientName' | 'status' | 'broker' | 'airports' | 'aircraft_ids' | 'operator_ids' | 'tail_numbers' | 'departureDate';

export interface ITripReportsDataState {
  filter: {
    filters: Array<{
      field: ITripReportsFilterField;
      filters: Array<{
        field: ITripReportsFilterField;
        operator: string;
        value: any;
      }>;
      logic: string;
    }>;
    logic: string;
  };
  sort: Array<{ field: ITripReportsFilterField; dir: 'asc' | 'desc'; }>;
  take: number;
  skip: number;
}

const defaultStatus = tripReportStatusList.find((item: any) => item.id === TRIP_REPORT_STATUS_ID.ALL);

export const initialState: { tripReportsFilter: ITripReportsFilter, dataState: ITripReportsDataState } = {
  tripReportsFilter: {
    clientName: '',
    status: defaultStatus ? [ defaultStatus ] :[],
    broker: [],
    airports: [],
    aircraft_ids: [],
    operator_ids: [],
    tail_numbers: [],
    departureDate: '',
  },
  dataState: {
    filter: {
      filters: [
        {
          'field': 'status',
          'filters': [ { 'field': 'status', 'operator': 'eq', 'value': TRIP_REPORT_STATUS_ID.ALL } ],
          'logic': 'or',
        },
      ],
      logic: 'and',
    },
    sort: [ { field: 'departureDate', dir: 'desc' } ],
    take: DEFAULT_PAGE_SIZE,
    skip: 0,
  },
};

const TripReportsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case type.TRIP_REPORTS_FILTER_CHANGE_HANDLER:
      return ({
        ...state,
        tripReportsFilter: { ...action.payload },
      });
    case type.TRIP_REPORTS_FILTER_LOADED:
      return ({
        ...state,
        dataState: action.payload,
      });
    default:
      return state;
  }
};

export default TripReportsReducer;

